/* eslint-disable */
export default {
  games: {
    '1': {
      place: '渋谷 宮益坂周辺'
    },
    '2': {
      place: '東京メトロ渋谷駅 (銀座線・副都心線・半蔵門線)<br/>B1出口周辺'
    },
    '3': {
      place: '渋谷 宮益坂上周辺'
    },
    '6': {
      place: '渋谷ハチ公周辺'
    },
    '7': {
      place: '大阪会場(道頓堀橋周辺)'
    },
    '8': {
      place: '名古屋会場(テレビトーヒロバ周辺)'
    }
  },
  firebaseErrors: {
    'auth/requires-recent-login':
      'セキュリティ上の理由から、最近ログインしている必要があります。 あなたの詳細を変更するには、再度ログインしてください',
    'auth/invalid-email': 'メールアドレスが正しくありません',
    'auth/email-already-in-use':
      'メールアドレスは既に別のユーザーによって使用されています',
    'auth/weak-password':
      '6 文字以上で、文字と数字を組み合わせた安全なパスワードを設定してください'
  },
  global: {
    authResourceFailedNotification: {
      title: 'ネットワークエラー',
      message: `エラーが発生しました。 機能が制限されている可能性があります。ページを更新してください。`,
      refresh: '更新する'
    }
  },
  editableField: {
    edit: '変更',
    submit: '変更を保存',
    cancel: 'キャンセル'
  },
  auth: {
    newUserNotification: {
      title: 'アカウントが作成されました！',
      message: 'ゲームに参加される際はこちらのアカウントをご利用ください。'
    }
  },
  timeslot: {
    fullText: '満員'
  },
  schedule: {
    noTimeslots: 'タイムスロットなし',
    info: '時間を選択すると会員登録・ログインに進みます'
  },
  account: {
    nextGame: {
      title: 'NEXT GAME',
      description: '予約の確認',
      none: '予約はありません'
    },
    payment: {
      title: 'PAYMENT',
      description: 'お支払い情報の確認・削除',
      none: '登録されたカードはありません',
      expires: 'EXP. ',
      delete: '削除'
    }
  },
  checkout: {
    progress: {
      '/checkout/tickets': '人数登録',
      '/login': 'ログイン',
      '/checkout/payment-sources': '支払方法',
      '/checkout/review': '支払確認',
      '/checkout/complete': '完了',
      '/checkout/confirm': '内容確認'
    },
    next: '次へ',
    newCard: {
      title: 'カードの登録',
      info: 'クレジットカードまたはデビットカードの情報を入力してください。',
      cardNumber: 'カード番号',
      cardCvc: 'CVC',
      cvcInfo: 'カードの裏の3桁または4桁の番号',
      cardExpiry: '有効期限',
      cancel: 'キャンセル',
      errorNotificationTitle: 'カードの登録ができませんでした',
      decline_code: {
        lost_card: 'カードが失われたと報告されたため、支払いが拒否されました。',
        generic_decline:
          '原因不明のエラーが発生しました。カード会社にお問い合わせください。',
        expired_card:
          'カードの有効期限が切れています。他のカードをお使いください。',
        fraudulent:
          '原因不明のエラーが発生しました。カード会社にお問い合わせください。',
        incorrect_cvc:
          'セキュリティコードが間違っています。正しい番号を入力してください。',
        insufficient_funds:
          'カードの利用限度額を超えています。他のカードをお使いください。',
        processing_error: 'もう一度お試しください。',
        live_mode_test_card:
          'カードは拒否されました。 リクエストはライブモードでしたが、既知のテストカードを使用しました',
        card_not_supported:
          'ご入力いただいたカードには対応しておりません。お手数ですが別のカードをご入力ください。'
      }
    },
    continue: {
      title: 'CONTINUE',
      subtitle: '内容を確認してください',
      msg_continue: 'コンティニュー代金　',
      msg_minute: '分／',
      msg_currency: '円',
      next_btn: '次へ'
    },
    sources: {
      title: 'PAY',
      info: 'お支払情報を入力してください',
      payWithCard: 'クレジットカード/デビットカードで支払う',
      useCoupon: 'クーポンコードを使う',
      payWithBrowser: 'で支払う',
      payAtKonbini: 'コンビニで支払う',
      konbiniInfo: '※ お支払方法の詳細はメールでご案内します。',
      'family-mart': 'ファミリーマート',
      'seven-eleven': 'セブンイレブン',
      'google-pay': 'グーグルパイ',
      'apple-pay': 'アップルペイ',
      lawson: 'ローソン',
      addCoupons: 'クーポン入力',
      addNewCard: '新しいカードを登録する',
      addCoupon: 'クーポンコードを持っていますか？ここをクリック',
      toPaymentConfirmation: '支払い確認へ'
    },
    review: {
      title: 'REVIEW',
      subtitle: 'ご予約情報の確認',
      game: 'ゲーム',
      date: 'ご予約日',
      time: 'ご予約時間',
      capacity: '容量',
      players: 'ご参加選手',
      coupons: 'クーポン',
      paymentInfo: 'お支払情報',
      pay: 'お支払いを確定する',
      tickets: '参加人数',
      subtotal: 'お支払小計',
      rentalDevices: 'レンタル機',
      weekdayTicket: '平日参加料',
      holidayTicket: '休日参加料',
      ticketCounter: '人分',
      deviceCounter: '台',
      total: 'お支払合計',
      place: '開始地点',
      placeDetailsInfo: '*メールでお知らせいたします'
    },
    review_continue: {
      title: 'REVIEW',
      name: 'コンティニュー',
      subtitle: '支払い確認',
      game: 'ゲーム',
      date: 'ご予約日',
      time: 'ご予約時間',
      capacity: '容量',
      players: 'ご参加選手',
      coupons: 'クーポン',
      paymentInfo: 'お支払情報',
      pay: 'お支払いを確定する',
      tickets: '参加人数',
      subtotal: 'お支払小計',
      rentalDevices: 'レンタル機',
      weekdayTicket: '平日参加料',
      holidayTicket: '休日参加料',
      ticketCounter: '人分',
      deviceCounter: '台',
      total: 'お支払合計',
      place: '開始地点',
      placeDetailsInfo: '*メールでお知らせいたします'
    },

    otherUserBookingTitle: '予約通知',
    otherUserBookingMessage:
      '別のユーザーがこのスロットの予約を行ったばかりです',
    fullyBookedTitle: '満員',
    fullyBookedMessage:
      '本当に申し訳ありませんが、そのタイムスロットは完全に予約されました。別のスロットを試してみてください！'
  },
  '404': {
    title: '入力したURLが当サイトのページと一致しません'
  }
};
